import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=4f363590&scoped=true&"
import script from "./Stock.vue?vue&type=script&lang=ts&"
export * from "./Stock.vue?vue&type=script&lang=ts&"
import style0 from "./Stock.vue?vue&type=style&index=0&id=4f363590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f363590",
  null
  
)

export default component.exports